import { Component, OnInit } from '@angular/core';

import { ModalController } from '@ionic/angular';

import { CameraPreview, CameraPreviewOptions } from '@capacitor-community/camera-preview';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'camera-overlay',
  templateUrl: './camera-overlay.component.html',
  styleUrls: [
    './camera-overlay.component.scss'
  ]
})
export class CameraOverlayComponent implements OnInit {

  photo: any = null;
  cameraActive: boolean = false;

  imageUrl: string | null = null;
  
  showGrid: boolean = false;
  imageOverlay: string = './assets/images/guide_720_1280.png';

  desktop: boolean = false;
  tablet: boolean = false;
  mobile: boolean = false;

  constructor(
    private modalController: ModalController,
    private translate: TranslateService
  ) {
    this.desktop = (window.innerWidth >= 1200);
    this.tablet = (window.innerWidth < 1200 && window.innerWidth >= 768);
    this.mobile = (window.innerWidth < 768);
  }

  ngOnInit() {
    this._getCameraPreviewPhoto();
  }

  ionViewWillEnter() {
    document.querySelector('body').classList.add('camera-active');
  }

  ionViewWillLeave() {
    document.querySelector('body').classList.remove('camera-active');
  }

  dismiss(data?: any) {
    this.modalController.dismiss(data);
  }

  _getCameraPreviewPhoto() {
    console.log(window.screen.width, window.screen.height);
    const cameraPreviewOptions: CameraPreviewOptions = {
      position: 'rear',
      parent: 'cameraPreview',
      className: 'cameraPreview',
      height: 1080,
      width: 1920,
      // width: window.screen.width,
      // height: window.screen.height,
      toBack: true,
      disableAudio: true,
      lockAndroidOrientation: true,
      enableZoom: true,
      disableExifHeaderStripping: false,
      rotateWhenOrientationChanged: false,
    };
    CameraPreview.start(cameraPreviewOptions);
    this.cameraActive = true;
  }
  
  async stopCamera(data?: any) {
    await CameraPreview.stop();
    this.cameraActive = false;
    this.dismiss(data);
  }

  async captureImage() {
    const cameraPreviewPictureOptions = {
      height: 1080,
      width: 1920,
      quality: 90
    };

    const result = await CameraPreview.capture(cameraPreviewPictureOptions);
    this.imageUrl = `data:image/jpeg;base64,${result.value}`;
    this.cameraActive = false;
  }

  async flipCamera() {
    await CameraPreview.flip();
  }

  returnToCamera() {
    this._getCameraPreviewPhoto();
  }

  acquirePhoto() {
    this.stopCamera({ image: this.imageUrl });
  }

  toggleGrid() {
    this.showGrid = !this.showGrid;
    this.imageOverlay = this.showGrid ? './assets/images/grid_720_1280.png' : './assets/images/guide_720_1280.png';
  }
}
